import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';

interface TabConfig {
  id: string | number;
  component: any;
  props?: Record<string, any>;
}

@Component
class EdTabsContent extends Vue {
  @Prop({ required: true }) readonly tabs!: TabConfig[];
  @Prop({ required: true }) readonly tab!: string | number;

  private previousTab: string | number | null = null;

  get transitionName() {
    const currentIndex = this.tabs.findIndex(tab => tab.id === this.tab);
    const previousIndex = this.previousTab !== null
        ? this.tabs.findIndex(tab => tab.id === this.previousTab)
        : currentIndex;

    return currentIndex > previousIndex ? 'fade-slide' : 'fade-slide-reverse';
  }

  get currentTabContent() {
    return this.tabs.find(tab => tab.id === this.tab) || null;
  }

  @Watch('tab', { immediate: true })
  onTabChange(newTab: string | number, oldTab: string | number | undefined) {
    this.previousTab = oldTab ?? this.tab;
  }
}

export default Vue.component('ed-tabs-content', EdTabsContent);